// extracted by mini-css-extract-plugin
export default {"table":"TeamUsersTable_table__HRcvr","row":"TeamUsersTable_row__e4XSA","text":"TeamUsersTable_text__CfPYu","actions":"TeamUsersTable_actions__0rwkJ"};